module.exports = __webpack_public_path__ + "static/media/loader.f92aa781.svg";